<div class="workflow-events">
  <h2 class="workflow-events__title">Actions</h2>
  <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
    <app-mat-text-input
      *ngIf="actions.length > 10"
      class="workflow-events__search-input"
      [prefixIcon]="'search'"
      [formControl]="searchControl"
      placeholder="Search"
    >
    </app-mat-text-input>
    <div
      *ngFor="let action of filteredActions"
      class="workflow-events__item"
      fExternalItem
      [fData]="action"
      [fDisabled]="action.disabled"
      [matTooltip]="action.description"
      fxLayout="row"
      fxLayoutAlign="start center"
      fxLayoutGap="10px"
      matTooltipPosition="right"
      (click)="actionClicked.next(action)"
    >
      <mat-icon>{{ action.icon }}</mat-icon>
      {{ action.name }}
    </div>
  </div>
</div>
